import React from 'react';
import { useAppSelector } from 'redux/hooks';
import { Navigate } from 'react-router-dom';
import redirectLinks from 'constants/redirectLinks';

/* ******** Main Component ******** */
/**
 * フィルタ
 * 認証の有無をチェックし、ない場合は認証チェック画面を表示。
 * セッションから認証情報を復元。
 *
 * @author atsushi.teruya
 * @returns {React.FC} - page component
 *
 */
const Filter: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { isUnauthorizedError, status } = useAppSelector((state) => state.common.errorInfo);

  // 認証チェック => セッションタイムアウトエラー ログイン、エラー画面、認証チェック画面は処理しない。
  if (isUnauthorizedError) {
    // 認証チェック画面へ遷移。
    return (
      <Navigate to={status === 0 ? redirectLinks.COMMON_AUTH_CHECK : redirectLinks.COMMON_SESSION_TIMEOUT_ERROR} />
    );
  }
  // 配下に指定されたコンポーネントを描画
  return <>{children}</>;
};

export default Filter;
